import {
    Button, Stack, Icon, Divider, Typography, Box,
    FormControlLabel, Checkbox, Grid
} from '@mui/material'

import { Fragment, useEffect, useState, useRef } from 'react'

import { useSelector } from 'react-redux'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import Link from '@components/Link'
import Alert from '@components/Alert'

import RequestHelp from '@views/Landingzones/Migration/Components/RequestHelp'

export const Inter = () => {
    const dataStore = useSelector(state => state.landingZoneMigration)

    const { getStatus, handleNext, handlePrevious } = useLandingZoneMigration()

    const [col1, setCol1] = useState([])
    const [col2, setCol2] = useState([])
    const [checked, setChecked] = useState([false, false])
    const [inProgress, setInProgress] = useState(false)
    const [hasDefaultRoutes, setHasDefaultRoutes] = useState(false)

    const timer = useRef()

    useEffect(() => {
        timer.current = setInterval(checkInterval, 10000)
        return () => { clearInterval(timer.current) }
    }, [])

    useEffect(() => {
        const data = dataStore.selected.interLzs ?? []

        if (data.length > 4) {
            const middle = Math.floor(data.length / 2);
            setCol1(data.slice(0, middle))
            setCol2(data.slice(middle))
        } else setCol1(data)

        setInProgress(dataStore.selected.inProgress)
        setHasDefaultRoutes(dataStore.selected.defaultRoutes)
    }, [dataStore.selected])

    const checkInterval = () => {
        getStatus(dataStore.selected.lzId, false)
    }

    return (
        <Fragment>
            <Divider sx={{mt: 2}}/>
            <Box sx={{p: 2}}>
                <Typography variant={'h5'} sx={{mb: 1}}>Inter Landing-Zone</Typography>
                {(!inProgress) && (
                    <Fragment>
                        <Typography variant={'h6'} sx={{fontWeight: 400, mb: 2}}>Please confirm the list of <strong>{parseInt(col1.length) + parseInt(col2.length)}</strong> linked Landing Zones below before migrate</Typography>

                        {((parseInt(col1.length) + parseInt(col2.length)) > 0) && (
                          <Fragment>
                              <Typography variant={'label'} sx={{fontWeight: 400, mb: 1}}>Linked Landing-Zones</Typography>

                              <Grid container sx={{mt: 2, mb: 2, height: '118px', overflow: 'auto'}}>
                                  <Grid item xs={6}>
                                      {col1.map(item => {
                                          return (<span key={item}>{item}<br /></span>)
                                      })}
                                  </Grid>
                                  <Grid item xs={6}>
                                      {col2.map(item => {
                                          return (<span key={item}>{item}<br /></span>)
                                      })}
                                  </Grid>
                              </Grid>
                          </Fragment>
                        )}

                        <Stack sx={{mb: 2}}>
                            <FormControlLabel
                                control={<Checkbox checked={checked[0]} onChange={(e) => setChecked([e.target.checked, checked[1]])} />}
                                label={'I confirm the list of linked Landing Zone is correct.'}
                            />
                            <FormControlLabel
                                control={<Checkbox checked={checked[1]} onChange={(e) => setChecked([checked[0], e.target.checked])} />}
                                label={<Stack direction={'row'} alignItems={'center'}><span>I confirm my application is</span>&nbsp;<Link external target={'_blank'} href={'https://digitalplatoforms.totalenergies.com'}>ready to migrate</Link></Stack>}
                            />
                        </Stack>

                        {hasDefaultRoutes && (
                            <Alert severity={'warning'} title={'Custom default routes detected.'} sx={{mb: 2}}>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <span>For more information, go to the</span>&nbsp;
                                    <Link external target={'_blank'} href={'https://digitalplatforms.totalenergies.com/documentation/platforms/azure-platform/inoxscale-platform/user-communication/major-network-change'} noIcon>documentation</Link>
                                </Stack>
                            </Alert>
                        )}

                        <Alert severity={'warning'} title={'Prepare you to a short interruption of service.'} />
                    </Fragment>
                )}

                {inProgress && (<Alert severity={'info'} title={'Inter Landing-Zone migration is in progress'} />)}

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{mt: 2}}>
                    <RequestHelp />
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'end'} spacing={1}>
                        <Button variant={'secondary'} disabled startIcon={<Icon>undo</Icon>} onClick={handlePrevious}>Rollback</Button>
                        <Button startIcon={<Icon>sync_alt</Icon>} onClick={handleNext} disabled={(!(checked[0] && checked[1]) || hasDefaultRoutes || inProgress)}>Migrate</Button>
                    </Stack>
                </Stack>
            </Box>
        </Fragment>
    )
}

export default Inter